import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';
import UserInput from "ui/ReactUserInput";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";
import BootstrapRow from "ui/BootstrapRow";
import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapCol from "ui/BootstrapCol";
import {useChildContext} from "root/Contexts/ChildContext";

export const emptyStarFundingData = {
   top_up_funding_flag: 0,
   dmy_funding_start_date:  '',
   dmy_funding_end_date:  '',
}

const StarFundingForm = React.forwardRef(({readOnly, displayErrors, child, mode}, ref) =>
{
   const { isPost16 } = useChildContext() ;

   const [isTopUpFlag, setTopupFlag] = useState(+(child.top_up_funding_flag) !== 0)

   const InputIsReceivingFunding = useRef(null);

   const InputFundingStartDate = useRef(null);
   const InputFundingEndDate = useRef(null);

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            top_up_funding_flag: isTopUpFlag  ? 1 : 0,
            dmy_funding_start_date: isTopUpFlag ? InputFundingStartDate.current.getValue() : '',
            dmy_funding_end_date: isTopUpFlag ? InputFundingEndDate.current.getValue() : '',
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (isTopUpFlag)
      {
         if (!InputFundingStartDate.current.isValid())
         {
            valid = false;
         }

         if (!InputFundingEndDate.current.isValid())
         {
            valid = false;
         }
      }

      return valid;
   }

   const onChangeTopUp = (newValue) =>
   {
      setTopupFlag(newValue);
   }

   let fieldType = readOnly === 'readonly' || mode === 'view' ? "readonly" : '';

   const rowTopUpDates = () =>
   {
      let funding_start_date = '';
      let funding_end_date = '';
      let fundingRequired;

      if (child.top_up_funding_flag != 0)
      {
         funding_start_date = child.dmy_funding_start_date;
         funding_end_date = child.dmy_funding_end_date;
      }

      if (isTopUpFlag === true)
      {
         fundingRequired = true;
      }
      else
      {
         fundingRequired = false;
         fieldType = "readonly";
      }

      return (
         <BootstrapRow>
            <div key='InputFundingStartDateDiv' className='col-md-6'>
               <UserInput validation={{required: fundingRequired, maxlen: 10, isDate: true}}
                          id='InputFundingStartDate'
                          name='InputFundingStartDate'
                          key='InputFundingStartDate'
                          ref={InputFundingStartDate}
                          placeholder='DD/MM/YYYY'
                          labelText='STAR Funding Start Date'
                          errorText='You must enter a valid date'
                          value={funding_start_date}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
            <div key='InputFundingEndDateDiv' className='col-md-6'>
               <UserInput validation={{required: false, maxlen: 10, isDate: true}}
                          id='InputFundingEndDate'
                          name='InputFundingEndDate'
                          key='InputFundingEndDate'
                          ref={InputFundingEndDate}
                          placeholder={'DD/MM/YYYY'}
                          labelText='STAR Funding End Date'
                          errorText='You must enter a valid date'
                          value={funding_end_date}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
         </BootstrapRow>

      )
   }

   const starFundingSection = () =>
   {
      return (
         <FieldsetContainer title='STAR Funding'>
            <BootstrapRow key='fundRow'>
               <div className='col-md-12'>
                  <UserInputCheckbox readOnly={readOnly}
                                     key='InputIsReceivingFunding'
                                     ref={InputIsReceivingFunding}
                                     onChange={onChangeTopUp}
                                     defaultValue={isTopUpFlag}
                                     label='Does the pupil receive STAR funding?'/>
               </div>
            </BootstrapRow>
            {isTopUpFlag === true && rowTopUpDates()}
         </FieldsetContainer>

      )
   }

   return (
      <BootstrapRow>
         <BootstrapCol width={12}>
         <BootstrapRow key='rowTopUpFundingDiv'>
            <BootstrapCol width={12}>
               { isPost16 === false && starFundingSection() }
            </BootstrapCol>
         </BootstrapRow>
         </BootstrapCol>
      </BootstrapRow>
   )
})

export default StarFundingForm;
